import createStore from '@utilities/store';

import { initialiseAlert } from './utilities/alert-utilitites';

export interface AlertItem {
    text: string | Text;
    isRendered: boolean;
}

export interface AlertState {
    alerts: AlertItem[];
}

const ADD_ALERT = 'addAlert';

const initialState: AlertState = {
    alerts: [],
};

const actions = {
    [ADD_ALERT]: (state: AlertState, payload: { text: string }) => {
        // Make sure alerts are loaded and added to the body
        initialiseAlert();

        // Add alert string
        state.alerts = [...state.alerts, { text: payload.text, isRendered: false }];

        return state;
    },
};

export const alertStore = createStore<AlertState>({
    initialState,
    actions,
});

export const addAlert = (text: string) => {
    alertStore.dispatch(ADD_ALERT, { text });
};
